/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseAntisocialForcesCheckInner } from './get-onboarding-request-by-id200-response-antisocial-forces-check-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseBeneficialOwnersInner } from './get-onboarding-request-by-id200-response-beneficial-owners-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseIdentityVerificationInner } from './get-onboarding-request-by-id200-response-identity-verification-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseOrganizationUsersInner } from './get-onboarding-request-by-id200-response-organization-users-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetOnboardingRequestById200ResponseSnailMailVerificationInner } from './get-onboarding-request-by-id200-response-snail-mail-verification-inner';

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200Response
 */
export interface GetOnboardingRequestById200Response {
    /**
     * 本社所在地：住所
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'address'?: string;
    /**
     * 反社チェック一覧
     * @type {Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'antisocialForcesCheck'?: Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInner>;
    /**
     * 実質的支配者
     * @type {Array<GetOnboardingRequestById200ResponseBeneficialOwnersInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'beneficialOwners'?: Array<GetOnboardingRequestById200ResponseBeneficialOwnersInner>;
    /**
     * 法人番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'corporateNumber'?: string;
    /**
     * 法人種別(enum)
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'corporateType'?: GetOnboardingRequestById200ResponseCorporateTypeEnum;
    /**
     * 作成日時
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'createdAt'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'email'?: string;
    /**
     * マイナンバーで確認済の認証情報一式
     * @type {Array<GetOnboardingRequestById200ResponseIdentityVerificationInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'identityVerification'?: Array<GetOnboardingRequestById200ResponseIdentityVerificationInner>;
    /**
     * 実質的支配者有無
     * @type {boolean}
     * @memberof GetOnboardingRequestById200Response
     */
    'isExistsBeneficialOwner'?: boolean;
    /**
     * マイナンバー検証サービスの検証ID
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'jpkiVerificationId'?: string;
    /**
     * メモ
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'note'?: string;
    /**
     * オンボーディング途中再開用のセッションID
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'onboardingSessionId'?: string;
    /**
     * 法人名
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'organizationName'?: string;
    /**
     * 初期作成ユーザー
     * @type {Array<GetOnboardingRequestById200ResponseOrganizationUsersInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'organizationUsers'?: Array<GetOnboardingRequestById200ResponseOrganizationUsersInner>;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'phoneNumber'?: string;
    /**
     * 本社所在地：郵便番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'postalCode'?: string;
    /**
     * 取引目的
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'purposeTransaction'?: GetOnboardingRequestById200ResponsePurposeTransactionEnum;
    /**
     * 取引目的その他自由記述
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'purposeTransactionOther'?: string;
    /**
     * 代表者氏名
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativeName'?: string;
    /**
     * 代表者電話番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativePhoneNumber'?: string;
    /**
     * 代表者生年月日
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativeBirthday'?: string;
    /**
     * 代表者住所
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativeAddress'?: string;
    /**
     * 郵送確認一覧
     * @type {Array<GetOnboardingRequestById200ResponseSnailMailVerificationInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'snailMailVerification'?: Array<GetOnboardingRequestById200ResponseSnailMailVerificationInner>;
}

export const GetOnboardingRequestById200ResponseCorporateTypeEnum = {
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE',
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type GetOnboardingRequestById200ResponseCorporateTypeEnum = typeof GetOnboardingRequestById200ResponseCorporateTypeEnum[keyof typeof GetOnboardingRequestById200ResponseCorporateTypeEnum];
export const GetOnboardingRequestById200ResponsePurposeTransactionEnum = {
    adExpenses: 'AD_EXPENSES',
    calculatedAsExpense: 'CALCULATED_AS_EXPENSE',
    other: 'OTHER',
    stocking: 'STOCKING',
    systemUsageFee: 'SYSTEM_USAGE_FEE'
} as const;

export type GetOnboardingRequestById200ResponsePurposeTransactionEnum = typeof GetOnboardingRequestById200ResponsePurposeTransactionEnum[keyof typeof GetOnboardingRequestById200ResponsePurposeTransactionEnum];


